module.exports = __webpack_public_path__ + "img/banner.8342aa46.jpg";